import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type {
  WorkIntegration_Keys,
  WorkIntegrationInstance,
} from '@/lib/api/types/work-integrations';
import { IntegrationInstancesAPI } from '@/lib/api/work-integrations/instances';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetIntegrationInstances = (
  sourceSystemType?: WorkIntegration_Keys,
  options?: Omit<UseQueryOptions<WorkIntegrationInstance[], Error>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.integrationInstances(sourceSystemType),
    queryFn: () => IntegrationInstancesAPI.getInstances(sourceSystemType),
    ...options,
  });
};
